module.exports = __webpack_public_path__ + "src/shared-components/icons/waitlist-blue.5756529766ef3401fd8dcc121e0c0d69.svg";